module.exports = "// Copyright (c) Microsoft. All rights reserved.\r\n// Licensed under the MIT license. See LICENSE file in the project root for full license information.\r\n\r\n#ifndef UTILITY_H\r\n#define UTILITY_H\r\n\r\nvoid parseTwinMessage(const char *);\r\nbool readMessage(int, char *);\r\nvoid sensorInit(void);\r\nvoid blinkLED(void);\r\nvoid blinkSendConfirmation(void);\r\nint getInterval(void);\r\n\r\n#endif /* UTILITY_H */"


//////////////////
// WEBPACK FOOTER
// ./src/data/GetStarted/utility.h
// module id = 405
// module chunks = 0